/** @jsx jsx */

import React, {
  Fragment as _,
  useLayoutEffect,
  useEffect,
  useRef,
  useContext,
  cloneElement,
} from 'react';
import { css, jsx } from '@emotion/core';
import { interactionContext as InteractionContext } from './interactionContext';
import CC_Sortation_Placeholder_Panel_Media from 'assets/CC_Sortation Placeholder_Panel Media 4.png';
// CC_Sortation Placeholder_Panel Media 3.png';
// CC_Sortation_Placeholder_Panel_Media.png';

export const SortableImage = props => {
  const context = useContext<any>(InteractionContext);

  const { children } = props;
  const Img = children[0];

  return (
    <div
      css={css({
        img: {
          maxHeight: '150px !important',
        },
      })}
    >
      {cloneElement(Img, {
        placeholder: CC_Sortation_Placeholder_Panel_Media,
      })}
    </div>
  );
};
